// src/components/foam/FoamToggle.js
//
// iOS-native pill toggle. 51×31, full radius, animated thumb.
// Doc: handoff README "Screen 5" — toggle spec.

import React from 'react';

const FoamToggle = ({ on, onChange, disabled = false, ariaLabel }) => (
  <button
    type="button"
    role="switch"
    aria-checked={on}
    aria-label={ariaLabel}
    onClick={() => !disabled && onChange?.(!on)}
    disabled={disabled}
    className={[
      'relative inline-block flex-shrink-0',
      'transition-colors duration-200',
      disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer',
    ].join(' ')}
    style={{
      width: 51,
      height: 31,
      borderRadius: 31,
      background: on ? 'var(--foam-toggle-on)' : 'var(--foam-toggle-off)',
      border: 'none',
      padding: 0,
    }}
  >
    <span
      className="absolute"
      style={{
        top: 2,
        left: on ? 22 : 2,
        width: 27,
        height: 27,
        borderRadius: '50%',
        background: '#fff',
        boxShadow: '0 3px 8px rgba(0,0,0,0.15), 0 3px 1px rgba(0,0,0,0.06)',
        transition: 'left 0.2s ease',
      }}
    />
  </button>
);

export default FoamToggle;
